import * as React from "react"
import { useTranslation } from "react-i18next"
import { matchPath } from "react-router-dom"

import LayoutWithSidebar, { SidebarItem } from "Catalog/shared/components/LayoutWithSidebar"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"

import DetailsNone from "../DetailsNone"

interface EditLayoutProps {
  toolbar: JSX.Element
  navigator: JSX.Element | null
  details: JSX.Element | null
  none: string
  noneSelected: string
  testId?: string
}

const EditLayout = ({ toolbar, navigator, details, none, noneSelected, testId }: EditLayoutProps): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigateNoUpdate()

  const { catalogNavigation } = useCatalogNavigation()

  const match = (path: string) => matchPath({ path, end: false }, window.location.pathname) !== null

  const sidebarItems: Array<SidebarItem> = [
    {
      text: t("sidebar.products.text"),
      shortcutLetter: t("sidebar.products.shortcut"),
      action: () => navigate(catalogNavigation.editLastVisitedPath("products")),
      isActive: match("/catalogs/:catalog_id/products"),
    },
    {
      text: t("sidebar.option_lists.text"),
      shortcutLetter: t("sidebar.option_lists.shortcut"),
      action: () => navigate(catalogNavigation.editLastVisitedPath("option_lists")),
      isActive: match("/catalogs/:catalog_id/option_lists"),
    },
    {
      text: t("sidebar.deals.text"),
      shortcutLetter: t("sidebar.deals.shortcut"),
      action: () => navigate(catalogNavigation.editLastVisitedPath("deals")),
      isActive: match("/catalogs/:catalog_id/deals"),
    },
    {
      text: t("sidebar.discounts.text"),
      shortcutLetter: t("sidebar.discounts.shortcut"),
      action: () => navigate(catalogNavigation.editLastVisitedPath("discounts")),
      isActive: match("/catalogs/:catalog_id/discounts"),
    },
    {
      text: t("sidebar.charges.text"),
      shortcutLetter: t("sidebar.charges.shortcut"),
      action: () => navigate(catalogNavigation.editLastVisitedPath("charges")),
      isActive: match("/catalogs/:catalog_id/charges"),
    },
  ]

  const main = navigator && (
    <>
      {navigator}
      {details || <DetailsNone text={noneSelected} />}
    </>
  )

  return (
    <LayoutWithSidebar
      toolbar={toolbar}
      sidebarItems={sidebarItems}
      main={main}
      none={none}
      displayMode="edit"
      testId={testId}
    ></LayoutWithSidebar>
  )
}

export default EditLayout
